/** Предзагрузка картинок, чтобы переворот карты был мгновенным. */
const loaded = new Set<string>();

export function preload(urls: (string | null | undefined)[]): void {
  for (const u of urls) {
    if (!u || loaded.has(u)) continue;
    loaded.add(u);
    const img = new Image();
    img.decoding = 'async';
    img.src = u;
  }
}
